export default function() {
	const buttons = document.querySelectorAll('.prose .button, #content-wrap .button, .prose .button-download, .back-menu');

	if ( buttons.length === 0 ) return;

	buttons.forEach(button => {
		const text = button.textContent
		const buttonSVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 8"><path fill="#BE0F34" fill-rule="evenodd" d="M.7.3H7a.7.7 0 0 1 .7.7v6.3a.7.7 0 1 1-1.4 0V2.69L1.495 7.495l-.99-.99L5.31 1.7H.7A.7.7 0 1 1 .7.3Z" clip-rule="evenodd"/></svg>'
		const buttonSVGWhite = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 8"><path fill="#ffffff" fill-rule="evenodd" d="M.7.3H7a.7.7 0 0 1 .7.7v6.3a.7.7 0 1 1-1.4 0V2.69L1.495 7.495l-.99-.99L5.31 1.7H.7A.7.7 0 1 1 .7.3Z" clip-rule="evenodd"/></svg>'
		const buttonDownloadSVG = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 19"><path fill="#BE0F34" d="M12.386 0H2.022C1.072 0 .295.777.295 1.727v12.091h1.727V1.728h10.364V0Zm-.864 3.455H5.477c-.95 0-1.719.777-1.719 1.727l-.009 12.09c0 .95.77 1.728 1.72 1.728h9.508c.95 0 1.727-.777 1.727-1.727V8.636l-5.182-5.181ZM5.477 17.273V5.182h5.182V9.5h4.318v7.773h-9.5Z"/></svg>'
		const buttonDownloadSVGWhite = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 19"><path fill="#ffffff" d="M12.386 0H2.022C1.072 0 .295.777.295 1.727v12.091h1.727V1.728h10.364V0Zm-.864 3.455H5.477c-.95 0-1.719.777-1.719 1.727l-.009 12.09c0 .95.77 1.728 1.72 1.728h9.508c.95 0 1.727-.777 1.727-1.727V8.636l-5.182-5.181ZM5.477 17.273V5.182h5.182V9.5h4.318v7.773h-9.5Z"/></svg>'
		const buttonSkipSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="16.15 16.43 14.7 15.14"><path fill="#BE0F34" d="M22.793 31.278a1 1 0 0 0 1.414 0l6.364-6.364a1 1 0 0 0-1.414-1.414L23.5 29.157 17.843 23.5a1 1 0 0 0-1.414 1.414l6.364 6.364ZM22.5 16.43v14.142h2V16.43h-2Z"/></svg>'
		const buttonSkipSVGWhite = '<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="16.15 16.43 14.7 15.14"><path fill="#ffffff" d="M22.793 31.278a1 1 0 0 0 1.414 0l6.364-6.364a1 1 0 0 0-1.414-1.414L23.5 29.157 17.843 23.5a1 1 0 0 0-1.414 1.414l6.364 6.364ZM22.5 16.43v14.142h2V16.43h-2Z"/></svg>'

		button.classList.add('group/button');
		if (  ! button.classList.contains('button--download') && ! button.getAttribute('href')?.startsWith('#') ) {
			button.classList.add('button--link');
		}

		if ( window.innerWidth < 768 && ! button.classList.contains('back-menu') ) {
			button.innerHTML = `
				<span>${text}</span>
			`;
		} else {
			button.innerHTML = `
				<span>${text}</span>
				<span>
					${button.classList.contains('button--download') ? `${buttonDownloadSVGWhite}${buttonDownloadSVG}` : 
						button.getAttribute('href')?.startsWith('#') ? `${buttonSkipSVGWhite}${buttonSkipSVG}` : 
						`${buttonSVGWhite}${buttonSVG}`}
				</span>
			`;
		}
		
	});
}




